import './_style.scss';

import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter} from 'reactstrap';

const ModalConfirmarRemoverContratoDoProtocolo = ({
  contratoBloqueado,
  isOpen,
  toggle,
  confirmar,
}) => { 

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-md modal-default">
    <ModalHeader toggle={toggle}>
      Deletar protocolo principal do contrato
      </ModalHeader>
    <ModalBody>
      <p className="text-alert">Deseja realmente remover  o contrato {contratoBloqueado.NumeroContrato} do atual protocolo principal?</p>
    </ModalBody>
    <ModalFooter>
      <Button className="btn_success" onClick={confirmar}>Sim</Button>
      <Button className="btn_danger" onClick={toggle}>Não</Button>
    </ModalFooter>
  </Modal>
  );
}

export default ModalConfirmarRemoverContratoDoProtocolo;
